<template>
  <div class="flex flex-column" style="height: 100%">
    <RouterView></RouterView>
  </div>
</template>

<script setup>
</script>
